import type { QueryClient } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';

import { setQueryPosition } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

// the lead, the lead list and the dashboard resubmission widgets all show the resubmission
export const invalidateResubmissionQueries = (queryClient: QueryClient, leadId: string, position?: number | null) => {
    if (position) {
        setQueryPosition(JSON.stringify(queryKeys.get(leadId)), position);
        setQueryPosition(JSON.stringify(queryKeys.getResubmissionLoanRequestsByDate()), position);
    }

    return Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.get(leadId) }),
        queryClient.invalidateQueries({ queryKey: queryKeys.getSummary() }),
        queryClient.invalidateQueries({
            queryKey: [AGGREGATE_NAMES.LOAN_REQUEST, LOAN_REQUEST_RESOLVERS.getResubmissionLoanRequestsByDate],
        }),
        queryClient.invalidateQueries({
            queryKey: [AGGREGATE_NAMES.LOAN_REQUEST, LOAN_REQUEST_RESOLVERS.getResubmissionCount],
        }),
    ]);
};
